/**
 * AjaxLoader
 * Lädt serverseitig gerenderte Inhalte via Fetch API asynchron nach.
 * Nutzt X-Requested-With für Contao-kompatible AJAX-Responses.
 */
export default class AjaxLoader {
  /**
   * Lädt eine URL und gibt den HTML-Inhalt als Text zurück.
   * @param {string} url - Die URL, die geladen werden soll.
   * @returns {Promise<string>} HTML-Inhalt
   */
  async load(url) {
    try {
      const response = await fetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      if (!response.ok) {
        throw new Error(`Fehler beim Laden: ${url}`);
      }
      return await response.text();
    } catch (error) {
      console.error('[AjaxLoader] Fehler:', error);
      return '<p>Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.</p>';
    }
  }
}
